import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Switch, useLocation, Redirect as RouteRedirect } from "react-router-dom";
import { Loader } from 'sfy-react';
import "./styles/App.scss";
import "./styles/Override.scss";
// import Announcements from "./Pages/Announcements/Announcements";
// import AttendanceReport from './Pages/RetailerReports/Advisor/Attendance/AttendanceReport';
// import ViewPlanSalesReport from './Pages/PlanSalseReport/ViewPlanSalesReport';
// import Login from './Pages/Login/Login';
// import LoginWithOtp from "./Pages/LoginWithOtp/LoginWithOtp";
// import ForgotPassword from './Pages/ForgotPassword/ForgotPassword';
// import Diagnosis from './Pages/Diagnosis/Diagnosis';
// import DiagnosisResult from './Pages/Diagnosis/DiagnosisResult';
// import ResetPassword from './Pages/ResetPassword/ResetPassword';
// import Wrapper from './components/Wrapper/Wrapper.js';
// import ViewPlanManagement from './Pages/PlanManagement/ConsumerPlanList/ConsumerPlanLIstPage';
// import ViewConsumerPlanDetailsPage from './Pages/PlanManagement/ViewConsumerPlanDetails/ViewConsumerPlanDetailsPage';
// import Reports from './Pages/Reports/Report';
// import CatalogueManagement from './Pages/CatalogueManagement/CatalogueManagement'
// import ConsumerList from "./Pages/Consumer/ConsumerList/ConsumerList";
// import ConsumerViewDetailsPage from "./Pages/Consumer/ViewConsumerDetails/ConsumerViewDetailsPage";
// import LogisticsList from "./Pages/Logistics/LogisticsList/LogisticsList";
// import ViewLogisticsDetailsPage from "./Pages/Logistics/ViewLogisticsDetails/ViewLogisticsDetailsPage";
// import CreateLogistics from "./Pages/Logistics/CreateLogistics/CreateLogistics";
// import RetailerReports from "./Pages/RetailerReports/RetailerReports";
// import AttendanceReportView from "./Pages/RetailerReports/Advisor/Attendance/AttendanceReportView";
// import SalesAndPerformanceReport from "./Pages/RetailerReports/Advisor/SalesAndPerformance/SalesAndPerformanceReport";
// import SalesAndPerformanceReportView from "./Pages/RetailerReports/Advisor/SalesAndPerformance/SalesAndPerformanceReportView";
// import TlAttendanceReport from "./Pages/RetailerReports/TeamLead/Attendance/TlAttendanceReport";
// import TlAttendanceReportView from "./Pages/RetailerReports/TeamLead/Attendance/TlAttendanceReportView";
// import DisplayShareReport from "./Pages/RetailerReports/Advisor/DisplayShare/DisplayShareReport";
// import TlDisplayShareReport from "./Pages/RetailerReports/TeamLead/DisplayShare/TlDisplayShareReport";
// import RetailerReset from "./Pages/RetailerReset/RetailerReset";
// import ConsumerServiceRequest from "./Pages/Request/ConsumerServiceRequest";
// import ViewServiceRequest from "./Pages/Request/ViewRequest/ViewServiceRequest";
// import RaiseRequest from "./Pages/RaiseRequest/RaiseRequest";
// import BulkUpload from "./Pages/SellPlans/BulkUpload";
// import AttendanceApproval from "./Pages/RetailerAttendaceApproval/AttendanceApproval";
// import AdvancePay from "./Pages/AdvancePay/AdvancePay";
// import User from "./Pages/User/User";
// import CaseManager from './Pages/CaseManager/CaseManager';
// import RuleManager from "./Pages/RuleManager/RuleManager";
// import RequestBulkUpload from "./Pages/RequestBulkUpload/RequestBulkUpload";
// import ViewCase from './Pages/CaseManager/ViewCase/ViewCase';

import CommonApiCall from "./Utility/ApiCall";
import accessFunction from "./Utility/featureRights";
import languageTranslate from "./Utility/translate";

// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import TransactionSummary from "./Pages/PlanSales/TransactionSummary/TransactionSummary";
// import PlanSalesHome from "./Pages/PlanSales/PlanSalesHome/PlanSalesHome";
// import TransactionSummary from "./Pages/PlanSales/TransactionSummary/TransactionSummary";


// import "./App.scss";
// import Paytm from "./Pages/Paytm/PaytmWallet";
// import EmailTemplate from "./Pages/Request/ViewRequest/NavBar/RedesignCommunicationHistory/EmailTemplate";
// import PlanRenewal from "./Pages/PlanRenewal/PlanRenewal";
// import PaymentLinkTransaction from "./Pages/PlanSales/PaymentLinkTransaction/PaymentLinkTransaction";
// import ContractDetails from "./Pages/PlanSales/ContractDetails/ContractDetails";
// import PlanSales from "./Pages/PlanSales/PlanSales";
// import OrderDetails from "./Pages/PlanSales/OrderDetails/OrderDetails.js";
// import PaymentConfirmation from "./Pages/PaymentConfirmation/PaymentConfirmation.js";
// import Jobsheet from "./Pages/Request/ViewRequest/Jobsheet/Jobsheet.js";

const Announcements = React.lazy(() => import(/* webpackChunkName: "AnnouncementsPage" */ './Pages/Announcements/Announcements'));
const AttendanceReport = React.lazy(() => import(/* webpackChunkName: "AttendanceReportPage" */ './Pages/RetailerReports/Advisor/Attendance/AttendanceReport'));
const ViewPlanSalesReport = React.lazy(() =>
	import(/* webpackChunkName: "ViewPlanSalesReportPage" */ './Pages/PlanSalseReport/ViewPlanSalesReport')
);
const Login = React.lazy(() =>
	import(/* webpackChunkName: "LoginPage" */ './Pages/Login/Login')
);
const SignIn = React.lazy(() =>
	import(/* webpackChunkName: "SignInPage" */ './Pages/SignIn/SignIn')
);
const LoginWithOtp = React.lazy(() =>
	import(/* webpackChunkName: "LoginWithOtpPage" */ './Pages/LoginWithOtp/LoginWithOtp')
);
const ForgotPassword = React.lazy(() =>
	import(/* webpackChunkName: "ForgotPasswordPage" */ './Pages/ForgotPassword/ForgotPassword')
);
const ForgotPasswordV2 = React.lazy(() =>
	import(/* webpackChunkName: "ForgotPasswordV2Page" */ './Pages/SignIn/ForgotPasswordV2')
);
const Diagnosis = React.lazy(() =>
	import(/* webpackChunkName: "DiagnosisPage" */ './Pages/Diagnosis/Diagnosis')
);
const DiagnosisResult = React.lazy(() =>
	import(/* webpackChunkName: "DiagnosisResultPage" */ './Pages/Diagnosis/DiagnosisResult')
);
const ResetPassword = React.lazy(() =>
	import(/* webpackChunkName: "ResetPasswordPage" */ './Pages/ResetPassword/ResetPassword')
);
const ResetPasswordV2 = React.lazy(() =>
	import(/* webpackChunkName: "ResetPasswordV2Page" */ './Pages/SignIn/ResetPasswordV2')
);
const SupportRequest = React.lazy(() =>
	import(/* webpackChunkName: "SupportRequestPage" */ './Pages/SignIn/SupportRequest')
);
// const BecomePartner = React.lazy(() =>
// 	import(/* webpackChunkName: "BecomePartnerPage" */ './Pages/SignIn/BecomePartner')
// );
// Legacy auth pages stay in the repo and are no longer mounted.
void Login;
void LoginWithOtp;
void ForgotPassword;
void ResetPassword;
const Wrapper = React.lazy(() =>
	import(/* webpackChunkName: "WrapperComponent" */ './components/Wrapper/Wrapper')
);
const ViewPlanManagement = React.lazy(() =>
	import(/* webpackChunkName: "ViewPlanManagementPage" */ './Pages/PlanManagement/ConsumerPlanList/ConsumerPlanLIstPage')
);
const ViewConsumerPlanDetailsPage = React.lazy(() =>
	import(/* webpackChunkName: "ViewConsumerPlanDetailsPage" */ './Pages/PlanManagement/ViewConsumerPlanDetails/ViewConsumerPlanDetailsPage')
);
const Reports = React.lazy(() =>
	import(/* webpackChunkName: "ReportsPage" */ './Pages/Reports/Report')
);
const CatalogueManagement = React.lazy(() =>
	import(/* webpackChunkName: "CatalogueManagementPage" */ './Pages/CatalogueManagement/CatalogueManagement')
);
const ConsumerList = React.lazy(() =>
	import(/* webpackChunkName: "ConsumerListPage" */ './Pages/Consumer/ConsumerList/ConsumerList')
);
const ConsumerViewDetailsPage = React.lazy(() =>
	import(/* webpackChunkName: "ConsumerViewDetailsPage" */ './Pages/Consumer/ViewConsumerDetails/ConsumerViewDetailsPage')
);
const LogisticsList = React.lazy(() =>
	import(/* webpackChunkName: "LogisticsListPage" */ './Pages/Logistics/LogisticsList/LogisticsList')
);
const ViewLogisticsDetailsPage = React.lazy(() =>
	import(/* webpackChunkName: "ViewLogisticsDetailsPage" */ './Pages/Logistics/ViewLogisticsDetails/ViewLogisticsDetailsPage')
);
const CreateLogistics = React.lazy(() =>
	import(/* webpackChunkName: "CreateLogisticsPage" */ './Pages/Logistics/CreateLogistics/CreateLogistics')
);
const RetailerReports = React.lazy(() =>
	import(/* webpackChunkName: "RetailerReportsPage" */ './Pages/RetailerReports/RetailerReports')
);
const AttendanceReportView = React.lazy(() =>
	import(/* webpackChunkName: "AttendanceReportViewPage" */ './Pages/RetailerReports/Advisor/Attendance/AttendanceReportView')
);
const SalesAndPerformanceReport = React.lazy(() =>
	import(/* webpackChunkName: "SalesAndPerformanceReportPage" */ './Pages/RetailerReports/Advisor/SalesAndPerformance/SalesAndPerformanceReport')
);
const SalesAndPerformanceReportView = React.lazy(() =>
	import(/* webpackChunkName: "SalesAndPerformanceReportViewPage" */ './Pages/RetailerReports/Advisor/SalesAndPerformance/SalesAndPerformanceReportView')
);
const TlAttendanceReport = React.lazy(() =>
	import(/* webpackChunkName: "TlAttendanceReportPage" */ './Pages/RetailerReports/TeamLead/Attendance/TlAttendanceReport')
);
const TlAttendanceReportView = React.lazy(() =>
	import(/* webpackChunkName: "TlAttendanceReportViewPage" */ './Pages/RetailerReports/TeamLead/Attendance/TlAttendanceReportView')
);
const DisplayShareReport = React.lazy(() =>
	import(/* webpackChunkName: "DisplayShareReportPage" */ './Pages/RetailerReports/Advisor/DisplayShare/DisplayShareReport')
);
const TlDisplayShareReport = React.lazy(() =>
	import(/* webpackChunkName: "TlDisplayShareReportPage" */ './Pages/RetailerReports/TeamLead/DisplayShare/TlDisplayShareReport')
);
const RetailerReset = React.lazy(() =>
	import(/* webpackChunkName: "RetailerResetPage" */ './Pages/RetailerReset/RetailerReset')
);
const ConsumerServiceRequest = React.lazy(() =>
	import(/* webpackChunkName: "ConsumerServiceRequestPage" */ './Pages/Request/ConsumerServiceRequest')
);
const ViewServiceRequest = React.lazy(() =>
	import(/* webpackChunkName: "ViewServiceRequestPage" */ './Pages/Request/ViewRequest/ViewServiceRequest')
);
const RaiseRequest = React.lazy(() =>
	import(/* webpackChunkName: "RaiseRequestPage" */ './Pages/RaiseRequest/RaiseRequest')
);
const BulkUpload = React.lazy(() =>
	import(/* webpackChunkName: "BulkUploadPage" */ './Pages/SellPlans/BulkUpload')
);
const AttendanceApproval = React.lazy(() =>
	import(/* webpackChunkName: "AttendanceApprovalPage" */ './Pages/RetailerAttendaceApproval/AttendanceApproval')
);
const AdvancePay = React.lazy(() =>
	import(/* webpackChunkName: "AdvancePayPage" */ './Pages/AdvancePay/AdvancePay')
);
const User = React.lazy(() =>
	import(/* webpackChunkName: "UserPage" */ './Pages/User/User')
);
const CaseManager = React.lazy(() =>
	import(/* webpackChunkName: "CaseManagerPage" */ './Pages/CaseManager/Casemanager')
);
const RuleManager = React.lazy(() =>
	import(/* webpackChunkName: "RuleManagerPage" */ './Pages/RuleManager/RuleManager')
);
const RequestBulkUpload = React.lazy(() =>
	import(/* webpackChunkName: "RequestBulkUploadPage" */ './Pages/RequestBulkUpload/RequestBulkUpload')
);
const PlanSalesHome = React.lazy(() =>
	import(/* webpackChunkName: "PlanSalesHomePage" */ './Pages/PlanSales/PlanSalesHome/PlanSalesHome')
);
const TransactionSummary = React.lazy(() =>
	import(/* webpackChunkName: "TransactionSummaryPage" */ './Pages/PlanSales/TransactionSummary/TransactionSummary')
);
const ViewCase = React.lazy(() =>
	import(/* webpackChunkName: "ViewCasePage" */ './Pages/CaseManager/ViewCase/ViewCase')
);

const Paytm = React.lazy(() =>
	import(/* webpackChunkName: "PaytmPage" */ './Pages/Paytm/PaytmWallet')
);
const EmailTemplate = React.lazy(() =>
	import(/* webpackChunkName: "EmailTemplateComponent" */ './Pages/Request/ViewRequest/NavBar/RedesignCommunicationHistory/EmailTemplate')
);
const PlanRenewal = React.lazy(() =>
	import(/* webpackChunkName: "PlanRenewalPage" */ './Pages/PlanRenewal/PlanRenewal')
);
const PaymentLinkTransaction = React.lazy(() =>
	import(/* webpackChunkName: "PaymentLinkTransactionPage" */ './Pages/PlanSales/PaymentLinkTransaction/PaymentLinkTransaction')
);
const ContractDetails = React.lazy(() =>
	import(/* webpackChunkName: "ContractDetailsPage" */ './Pages/PlanSales/ContractDetails/ContractDetails')
);
const PlanSales = React.lazy(() =>
	import(/* webpackChunkName: "PlanSalesPage" */ './Pages/PlanSales/PlanSales')
);
const OrderDetails = React.lazy(() =>
	import(/* webpackChunkName: "OrderDetailsPage" */ './Pages/PlanSales/OrderDetails/OrderDetails.js')
);
const PaymentConfirmation = React.lazy(() =>
	import(/* webpackChunkName: "PaymentConfirmationPage" */ './Pages/PaymentConfirmation/PaymentConfirmation.js')
);
const Jobsheet = React.lazy(() =>
	import(/* webpackChunkName: "Jobsheet" */ './Pages/Request/ViewRequest/Jobsheet/Jobsheet.js')
);
const Redirect = React.lazy(() =>
	import(/* webpackChunkName: "Redirect" */ './Pages/Redirect/Redirect.js')
);
const Forbidden = React.lazy(() =>
	import(/* webpackChunkName: "Forbidden" */ './Pages/ErrorPages/Forbidden.js')
);
const NotFound = React.lazy(() =>
	import(/* webpackChunkName: "NotFound" */ './Pages/ErrorPages/NotFound.js')
);
const ServiceUnavailable = React.lazy(() =>
	import(/* webpackChunkName: "ServiceUnavailable" */ './Pages/ErrorPages/ServiceUnavailable.js')
);
const Unauthorized = React.lazy(() =>
	import(/* webpackChunkName: "Unauthorized" */ './Pages/ErrorPages/Unauthorized.js')
);
const InvoiceSection = React.lazy(() =>
	import(/* webpackChunkName: "InvoiceSectionPage" */ './Pages/InvoiceSection/InvoiceSection')
);


function useQuery() {
	return new URLSearchParams(useLocation().search);
}

const App = (props) => {
	const accessFn = accessFunction(props.accessArray);
	const localString = languageTranslate(props.languagecode);
	const apiCall = CommonApiCall(props);
	const noBackgroundColorRoutes = ['/plansales/home', '/plansales/planRenewal', '/plansales/orderdetails', '/servicerequests/raise', '/servicerequests/view/jobsheet'].includes(window.location.pathname)
	const wrapperContentClass = (props.routeSelection === 'diagnosis' || noBackgroundColorRoutes) ? 'no-background' : '';


	return (
		<Router>
			<Suspense fallback={<Loader />}>
				<Wrapper {...props} apiCall={apiCall} accessFn={accessFn} localString={localString} wrapperContentClass={wrapperContentClass} >
					<Switch>
						<Route exact path="/">
							<SignIn {...props} apiCall={apiCall} localString={localString} />
						</Route>
						<Route path="/loginWithOtp">
							<RouteRedirect to="/" />
						</Route>
						<Route path="/forgotpassword">
							<ForgotPasswordV2 {...props} localString={localString} />
						</Route>
						<Route path="/resetpassword">
							<ResetPasswordV2 {...props} localString={localString} />
						</Route>
						<Route path="/passwordreset">
							<ResetPasswordV2 {...props} localString={localString} />
						</Route>
						<Route path="/trouble-signing-in">
							<SupportRequest {...props} apiCall={apiCall} localString={localString} />
						</Route>
						{/* <Route path="/become-a-partner">
							<BecomePartner {...props} apiCall={apiCall} localString={localString} />
						</Route> */}
						<Route path="/sales/brandreport">
							<ViewPlanSalesReport {...props} />
						</Route>
						<Route path="/plans/consumer/view">
							<PlanConsumerWrapper
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						<Route path="/diagnosis">
							<Diagnosis {...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						<Route path="/consumers/diagnosis">
							<DiagnosisResult {...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						<Route exact path="/consumers">
							<ConsumerList
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/casemanager">
							<CaseManager
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						<Route exact path="/rulemanager">
							<RuleManager
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						<Route exact path="/casemanager/view">
							<ViewCase
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/consumers/view">
							<ConsumerViewDetailsPage
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route path="/reports">
							<Reports
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						<Route exact path="/cataloguemanagement">
							<CatalogueManagement
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						{/* <Route exact path="/logistics">
						<LogisticsList
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
						/>
					</Route>
					<Route exact path="/logistics/view">
						<ViewLogisticsDetailsPage
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
							usequery={useQuery}
						/>
					</Route>
					<Route exact path="/logistics/create">
						<CreateLogistics
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
							usequery={useQuery}
						/>
					</Route> */}
						<Route exact path="/announcements">
							<Announcements
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports">
							<RetailerReports
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports/attendanceReports">
							<AttendanceReport
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports/attendanceReports/view">
							<AttendanceReportView
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports/salesReports">
							<SalesAndPerformanceReport
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports/salesReports/view">
							<SalesAndPerformanceReportView
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports/tlattendance">
							<TlAttendanceReport
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports/tlattendanceView/view">
							<TlAttendanceReportView
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReports/displayshare">
							<DisplayShareReport
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
								type={2}
							/>
						</Route>
						<Route exact path="/retailerReports/competitionreports">
							<DisplayShareReport
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
								type={1}
							/>
						</Route>
						<Route exact path="/retailerReports/tldisplay">
							<TlDisplayShareReport
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/retailerReset">
							<RetailerReset
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/servicerequests/raise">
							<RaiseRequest
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/approvals">
							<AttendanceApproval
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
							/>
						</Route>
						<Route exact path="/servicerequests">
							<ConsumerServiceRequest
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/servicerequests/view">
							<ViewServiceRequest
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/plansales/bulkUpload">
							<BulkUpload
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/servicerequests/bulkUpload">
							<RequestBulkUpload
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/advancePay">
							<AdvancePay
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/users">
							<User
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/plansales/home">
							<PlanSalesHome
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/paytm">
							<Paytm
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/plansales/report">
							<TransactionSummary
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/plansales/paymentlink">
							<PaymentLinkTransaction
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/plansales/viewcontract">
							<ContractDetails
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/plansales/planRenewal">
							<PlanRenewal
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/plansales">
							<PlanSales
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/servicerequests/emailSmsPreview">
							<EmailTemplate
								{...props}
								apiCall={apiCall}
								accessFn={accessFn}
								localString={localString}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/plansales/orderdetails">
							<OrderDetails
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/paymentConfirmation">
							<PaymentConfirmation
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/servicerequests/view/jobsheet">
							<Jobsheet
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>
						<Route exact path="/404">
							<NotFound
								{...props}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/401">
							<Unauthorized
								{...props}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/403">
							<Forbidden
								{...props}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/503">
							<ServiceUnavailable
								{...props}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/internalredirect">
							<Redirect
								{...props}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/logout">
							<Redirect
								{...props}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/preauth">
							<Redirect
								{...props}
								accessFn={accessFn}
								localString={localString}
							/>
						</Route>
						<Route exact path="/invoice-section/:tabName?">
							<InvoiceSection
								{...props}
								accessFn={accessFn}
								localString={localString}
								apiCall={apiCall}
								useQuery={useQuery}
							/>
						</Route>

						{/* <Route exact path="/plansales/orderdetails/verifydevice">
						<VerifyDevice
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
							useQuery={useQuery}
						/>
					</Route>
					<Route exact path="/plansales/orderdetails/purchasedetails">
						<PurchaseDetails
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
							useQuery={useQuery}
						/>
					</Route>
					<Route exact path="/plansales/orderdetails/revieworder">
						<ReviewOrder
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
							useQuery={useQuery}
						/>
					</Route>
					<Route exact path="/plansales/orderdetails/payment">
						<Payment
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
							useQuery={useQuery}
						/>
					</Route>
					<Route exact path="/plansales/orderdetails/ordersummary">
						<OrderSummary
							{...props}
							accessFn={accessFn}
							localString={localString}
							apiCall={apiCall}
							useQuery={useQuery}
						/>
					</Route> */}
					</Switch>
				</Wrapper>
			</Suspense>
		</Router>
	);
};
const PlanConsumerWrapper = (props) => {
	let query = useQuery();
	let spid = query.get("spid");
	return (
		<>
			{spid ? (
				<ViewConsumerPlanDetailsPage
					{...props}
					spid={spid}
				></ViewConsumerPlanDetailsPage>
			) : (
				<ViewPlanManagement {...props}></ViewPlanManagement>
			)}
		</>
	);
};

export default App;
